export const isInRange = (x: number, min: number, max: number | undefined | null): boolean => {
    if (max !== undefined && max !== null) {
        // is all equal
        if (x === min && x === max) return true;
        // is between
        if (x >= min && x <= max) return true;
    } else if (x >= min) {
        // is over min
        return true;
    }
    return false;
};

export const isAboveNCharacters = (text: string, n: number) => {
    return text.length > n;
};
